export default "__VITE_ASSET__CQGIowtb__"